/** Banner animado del programa 2do Escalón (señal TNO) */
export const ANIMATED_COVER_2DO_ESCALON_URL =
  'https://files.tnonetwork.com/shows/animated_cover/2doescalon.mp4';

export const SHOW_COVER_2DO_ESCALON_URL =
  'https://files.tnonetwork.com/shows/ondemand_main/2doescalon.jpg';

export const SHOW_LOGO_2DO_ESCALON_URL =
  'https://files.tnonetwork.com/shows/logo/2doescalon.png';
